.cue-card-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
